var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "categ_block" }, [
    _c("div", { staticClass: "panel-tag" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.__t("REST_FILTER_CATEG_INFO")) + "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "categ_list p-3" },
      [
        _c("categlist", {
          attrs: { categories: this.categories },
          on: { change: _vm.set_active_categ },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }